import { Injectable,Renderer2,RendererFactory2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PrimeNG } from 'primeng/config';
import {updatePreset,palette} from '@primeuix/themes';
 
 

@Injectable({
  providedIn: 'root'
})
export class Themecolors {
  private renderer!:Renderer2 ;
  private currentClass="";
  private themes:any={};
  constructor (private primeng:PrimeNG,private http:HttpClient,private rendererFactory:RendererFactory2){
    this.renderer=rendererFactory.createRenderer(null,null)
  }
  async loadThemes(){
    this.themes={
      "blue":{
        "colors":{
         /*  "primary-bg":"#ff4500",
          "secondary":"#32cd32",
          "background":"#fafafa",
           */
         //'title-text-color': "red"
        }
      },
      "cyan":{
        "colors":{
          /* "primary-bg":"#ff4500",
          "secondary":"#32cd32",
          "background":"#fafafa" */
        }
      },
      "purple":{
        "colors":{
          /* "primary-bg":"#ff4500",
          "secondary":"#32cd32",
          "background":"#fafafa" */
        }
      },
      "orange":{
        "colors":{
          /* "primary-bg":"#ff4500",
          "secondary":"#32cd32",
          "background":"#fafafa" */
        }
      },
       


       }
    return Object.keys(this.themes)
  }
  
  setTheme(themeName:string){
    const tokens=this.themes[themeName]
    const existinglink=document.getElementById('exsheet')
    if(existinglink){
      this.renderer.removeChild(document.head,existinglink)
    }
    const style=this.renderer.createElement('style');
    
    this.renderer.setAttribute(style,'id','exsheet');
    style.textContent=":root{"
    if(!tokens) return;
    for(const category of Object.keys(tokens)){
    for(const[key,value] of Object.entries(tokens[category])){
        const varName=`--${key}:${value};`;
        style.textContent+=varName
      }
    }
    style.textContent+="}";
    this.renderer.appendChild(document.head,style)
  
    const paletename=`{${themeName}}`;
 
    updatePreset({
      semantic:{
        primary:palette(paletename),
        secondary:palette('{gray}')
      }
    })
  }
}
